const loaded: Record<string, Promise<void>> = {};

export function ensureScript(url: string) {
	if (!!loaded[url]) return loaded[url];
	return (loaded[url] = loadScript(url));
}

export function loadScript(url: string): Promise<void> {
	// todo make sure this works universally for all browsers
	return new Promise<void>((resolve, reject) => {
		const script = document.createElement('script');
		script.src = url;
		script.onload = () => {
			console.log('Loaded', url);
			resolve();
		};
		script.onerror = () => {
			console.warn('failed to load', url);
			reject();
		};
		script.type = 'text/javascript';
		document.body.appendChild(script);
	});
}
